import React, { Component, Fragment } from "react";
import { withTranslation } from "react-i18next";
import Chrome from "../../../../../static/images/chrome.png";
import Mozilla from "../../../../../static/images/mozilla.png";
import Explorer from "../../../../../static/images/explorer.svg";
import AppName from "../../../../../static/images/appName.png";

export class LoginTemplate extends Component {
  render() {
    const { t } = this.props;
    return (
      <Fragment>
        <div className="wrapper-login">
          <div className="login-wrapper">
            <header className="main-login-header">
              <div className="login-header-container">
                <div className="container-item">
                  <img src={AppName} alt="Nombre" />
                </div>
                <div className="browser">
                  <p className="title">Sitio optimizado para:</p>
                  <p className="browser-supported">
                    <img
                      src={Explorer}
                      alt="Navegadores soportados"
                    />{" "}
                    IE 11+
                  </p>
                  <p className="browser-supported">
                    <img
                      src={Mozilla}
                      alt="Navegadores soportados"
                    />{" "}
                    Mozilla Firefox
                  </p>
                  <p className="browser-supported">
                    <img
                      src={Chrome}
                      alt="Navegadores soportados"
                    />{" "}
                    Google Chrome
                  </p>
                </div>
              </div>
            </header>
            <div className="landing-img">
              <div className="title-box">{t("login.banner.title")}.</div>
            </div>
            {this.props.children}
          </div>
        </div>
      </Fragment>
    );
  }
}

export default withTranslation()(LoginTemplate);
